<template>
  <v-hover v-slot="{ hover }">
    <v-btn
      rounded
      class="!absolute !top-5 !left-5 !z-10 pa-5 font-Handel !text-[#b19141]"
      color="black"
      dark
    >
      <v-icon color="#b19141">
        {{ premium ? "mdi-crown-outline" : "mdi-seal" }}
      </v-icon>
      {{ hover ? (premium ? "Premium Member" : "Basic Member") : "" }}
    </v-btn>
  </v-hover>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    premium() {
      return this.$store.getters.isPremium;
    },
  },
};
</script>
<style scoped></style>
